import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  isUserLoggedIn,
  // getUserData,
  // getHomeRouteForLoggedInUser,
} from '@/auth/utils'
import { canNavigate } from '@/libs/acl/routeProtection'
// import ability from '@/libs/acl/ability'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
        resource: 'LoggedIn',
      },
    },
    {
      path: '/apps',
      name: 'apps',
      component: () => import('@/views/app_section/Applications.vue'),
      meta: {
        // pageTitle: 'اپلیکیشن ها',
        // breadcrumb: [
        //   {
        //     text: 'اپلیکیشن ها',
        //     active: false,
        //   },
        // ],
        resource: 'LoggedIn',
      },
    },
    {
      path: '/apps/new',
      name: 'apps-create',
      component: () => import('@/views/app_section/ApplicationForm.vue'),
      meta: {
        resource: 'LoggedIn',
      },
    },
    {
      path: '/apps/edit/:id',
      name: 'apps-edit',
      props: route => {
        const id = Number.parseInt(route.params.id, 10)
        if (Number.isNaN(id)) {
          return 0
        }

        return { id }
      },
      component: () => import('@/views/app_section/ApplicationForm.vue'),
      meta: {
        resource: 'LoggedIn',
      },
    },
    {
      path: '/second-page',
      name: 'second-page',
      component: () => import('@/views/SecondPage.vue'),
      meta: {
        pageTitle: 'Second Page',
        breadcrumb: [
          {
            text: 'Second Page',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/authentication/Login.vue'),
      meta: {
        layout: 'full',
        redirectIfLogin: true,
        resource: 'Auth',
      },
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/authentication/Register.vue'),
      meta: {
        layout: 'full',
        redirectIfLogin: true,
        resource: 'Auth',
      },
    },
    {
      path: '/campaigns',
      name: 'campaigns',
      component: () => import('@/views/campaigns/Campaigns.vue'),
      meta: {
        resource: 'LoggedIn',
      },
    },
    {
      path: '/campaigns/new',
      name: 'campaigns-create',
      component: () => import('@/views/campaigns/CampaignForm.vue'),
      meta: {
        resource: 'LoggedIn',
      },
    },
    {
      path: '/campaigns/edit/:id',
      name: 'campaigns-edit',
      props: route => {
        const id = Number.parseInt(route.params.id, 10)
        if (Number.isNaN(id)) {
          return 0
        }

        return { id }
      },
      component: () => import('@/views/campaigns/CampaignForm.vue'),
      meta: {
        resource: 'LoggedIn',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    if (!isLoggedIn) return next({ name: 'login' })

    // If logged in => not authorized
    console.log('i should not be here')
    return next({ name: 'error-404' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLogin && isLoggedIn) {
    // const userData = getUserData()
    next('/')
    // next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
